(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordian"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded",function(){

const items=document.querySelectorAll(".faq-item");

items.forEach(function(item){

const question=item.querySelector(".faq-question");

question.addEventListener("click",function(){

const active=document.querySelector(".faq-item.active");

if(active && active!==item){
active.classList.remove("active");
}

item.classList.toggle("active");

});

});

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('.faq-item');

    items.forEach(function (item) {
      const question = item.querySelector('.faq-question');

      question.addEventListener('click', function () {
        const active = document.querySelector('.faq-item.active');

        if (active && active !== item) {
          active.classList.remove('active');
        }

        item.classList.toggle('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
